export const LockedWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z"
      fill="#041C1B"
      fillOpacity="0.2"
    />
    <path
      d="M12 5.90039C12.663 5.90039 13.2987 6.16397 13.7676 6.63281C14.2363 7.10163 14.5 7.73744 14.5 8.40039V9.90039H16.3643C16.8955 9.90073 17.2998 10.3407 17.2998 10.8506V17.1504C17.2996 17.6601 16.8953 18.1002 16.3643 18.1006H7.63672C7.13856 18.1006 6.75169 17.7135 6.70508 17.2451L6.7002 17.1504V10.8506C6.7002 10.3405 7.10519 9.90039 7.63672 9.90039H9.5V8.40039C9.5 7.73744 9.7637 7.10163 10.2324 6.63281C10.7013 6.16397 11.337 5.90039 12 5.90039ZM7.7002 17.1006H16.2998V10.9004H7.7002V17.1006ZM12 13.75C12.4142 13.75 12.75 14.0858 12.75 14.5C12.75 14.9142 12.4142 15.25 12 15.25H11.999C11.585 15.2497 11.249 14.9141 11.249 14.5C11.249 14.0859 11.585 13.7503 11.999 13.75H12ZM12 6.90039C11.6022 6.90039 11.2208 7.05854 10.9395 7.33984C10.6583 7.62113 10.5 8.00266 10.5 8.40039V9.90039H13.5V8.40039C13.5 8.00266 13.3417 7.62113 13.0605 7.33984C12.7792 7.05854 12.3978 6.90039 12 6.90039Z"
      fill="white"
    />
  </svg>
);
